module.exports = __webpack_public_path__ + "img/logo_love.6d0aba3c.png";